import DOATask from 'forms/containers/DelegationOfAuthority/DOATask';
export default DOATask;
